<section id="list-service-orders">
  <div [ngClass]="{'header-container-content-desktop': !isPhone,
  'header-container-content-phone': isPhone   
  }">


  <header id="title">
    <h3>Ordem de Serviço</h3>
  </header>

  <div class="filter-container">
    <mat-form-field appearance="legacy">
      <input [(ngModel)]="ordersListParams.term"
        (ngModelChange)="handleSearchChange($event)"
        matInput
        type="search"
        style="padding: 4px;"
        placeholder="Pesquisar pelo nome da OS">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>


  </div>

</section>

<div class="c-container">
  <div class="card-single">
    <div class="header-card" style="padding: 1.2rem;">
      <span class="count-orders">{{ serviceOrdersList.AwaitingOrder ? serviceOrdersList.AwaitingOrder.length : 0 }}</span>
      <span style="color: #2c2b2c;">EM ESPERA</span>
    </div>
    <div class="scrollable-card-content">
      <app-card-service-order *ngFor="let serviceOrder of serviceOrdersList.AwaitingOrder" [serviceOrderCard]="serviceOrder"></app-card-service-order>
    </div>  
  </div>

  <div class="card-single">
    <div class="header-card" style="padding: 1.2rem;">
      <span class="count-orders">{{ serviceOrdersList.ProgressOrder ? serviceOrdersList.ProgressOrder.length : 0 }}</span>
      <span style="color: #2c2b2c;">EM PROGRESSO</span>
    </div>
    <div class="scrollable-card-content">
      <app-card-service-order *ngFor="let serviceOrder of serviceOrdersList.ProgressOrder" [serviceOrderCard]="serviceOrder"></app-card-service-order>
    </div> 
  </div>

  <div class="card-single">
    <div class="header-card" style="padding: 1.2rem;">
      <span class="count-orders">{{ serviceOrdersList.FinishOrder ? serviceOrdersList.FinishOrder.length : 0 }}</span>
      <span style="color: #2c2b2c;">FINALIZADOS</span>
    </div>
    <div class="scrollable-card-content">
      <app-card-service-order *ngFor="let serviceOrder of serviceOrdersList.FinishOrder" [serviceOrderCard]="serviceOrder"></app-card-service-order>
    </div> 
  </div>
  
  <div class="card-single">
    <div class="header-card" style="padding: 1.2rem;">
      <span class="count-orders">{{ serviceOrdersList.CanceledOrder ? serviceOrdersList.CanceledOrder.length : 0 }}</span>
      <span style="color: #2c2b2c;">CANCELADOS</span>
    </div>
    <div class="scrollable-card-content">
      <app-card-service-order *ngFor="let serviceOrder of serviceOrdersList.CanceledOrder" [serviceOrderCard]="serviceOrder"></app-card-service-order>
    </div> 
  </div>
</div>

<button 
  mat-fab 
  color="primary" 
  class="agil-web-fab"
  (click)="handleOpenModalAddServiceOrder()">
    <mat-icon>add</mat-icon>
</button>


